/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContacts from '../contactsPage/modal/ModalContacts';
import './ErrorPage.css';
import '../../components/buttons/mainBtn.css';
import { Container } from 'react-bootstrap';
import { Button } from '../../shared/ui';
import { api } from '../../redux/api';
import { useGetClientId } from '../../hookServices/clientId';
import { useContactUsTelegramPreferred } from '../../hookServices/useContactUsTelegramPreferred';
import { TELEGRAM_BOT } from '../../environment';
import ReactGA from 'react-ga';

const ErrorPage = ({
  errorHeader,
  errorBody,
  startAgain,
  stationNumber,
  children,
  afterMessageChildren,
  belowMessageChildren,
  footerChildren,
  hideContactUs = false,
  isInServicePage = false,
  centerOnScreen = false,
}) => {
  const [isStartAgain, setIsStartAgain] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  const { clientId } = useGetClientId();
  const { preferTelegram: preferTelegramForContact, lastPortForLink } = useContactUsTelegramPreferred();

  const handleContactUs = () => {
    if (preferTelegramForContact && clientId) {
      ReactGA.event({
        category: 'contacts',
        action: 'telegram from error page (last session port < 30 kW)',
      });
      window.open(
        `https://t.me/${TELEGRAM_BOT}?start=${encodeURIComponent(clientId)}-${lastPortForLink || stationNumber || ''}`,
        '_blank'
      );
    } else {
      setModalOpen(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const mainScroll = document.getElementById('layoutMainScroll');
    if (mainScroll) {
      mainScroll.scrollTop = 0;
    }
  }, []);

  useEffect(() => {
    document.body.classList.add('error-page-active');
    return () => document.body.classList.remove('error-page-active');
  }, []);

  useEffect(() => {
    if (startAgain === true) {
      setIsStartAgain(true);
    }
  }, [startAgain]);

  // Check if this is an offline station page
  const isOfflinePage =
    !isInServicePage &&
    (errorHeader === t('stationOffline') ||
      (errorBody &&
        (errorBody.includes('Немає світла') || errorBody.includes('Нет света') || errorBody.includes('No power'))));

  const compactFooterLayout = Boolean(footerChildren);

  const bodyStyle =
    isInServicePage || centerOnScreen || isOfflinePage
      ? undefined
      : {
          marginTop: '48px',
          color: '#fff',
          maxWidth: '600px',
          marginLeft: 'auto',
          marginRight: 'auto',
        };

  const bodyClassName = [
    'body',
    isInServicePage ? 'port-in-service-message' : '',
    isOfflinePage ? 'error-page-offline-body' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const messageBlock = (
    <>
      {!isOfflinePage && errorHeader && (
        <p id="errorPageHeader" className="title">
          {errorHeader}
        </p>
      )}
      {errorBody && (
        <p id="errorPageBody" className={bodyClassName} style={bodyStyle}>
          {errorBody}
        </p>
      )}
      {afterMessageChildren && (
        <div className={`error-page-after-message${isOfflinePage ? ' error-page-after-message--offline' : ''}`}>
          {afterMessageChildren}
        </div>
      )}
    </>
  );

  const childrenBlock = children ? (
    <div
      className={isOfflinePage ? 'error-page-top-content' : undefined}
      style={{ marginTop: isOfflinePage ? 0 : centerOnScreen ? '16px' : '20px' }}
    >
      {children}
    </div>
  ) : null;

  const actionsBlock = (
    <>
      {/* Offline: location/port already rendered above the message. */}
      {!isOfflinePage && childrenBlock}

      {isStartAgain ? (
        <div className="mainBtnText">
          <br />
          <p>
            <Button className={'mainBtnText'} link={`/start?station=${stationNumber}`}>
              {t('startNew')}
            </Button>
          </p>
        </div>
      ) : (
        !hideContactUs && (
          <div className="mainBtnText">
            <br />
            <p>
              <Button className={'mainBtnText'} onClick={handleContactUs}>
                {t('contactUs')}
              </Button>
            </p>
          </div>
        )
      )}
      <div className="mainBtnText">
        <br />
        <p>
          <Button className={'mainBtnText'} link={`/`}>
            {t('btns.getNearestStationsStatus')}
          </Button>
        </p>
      </div>
      {footerChildren && (
        <div className="mainBtnText" style={{ marginTop: '10px', marginBottom: 0, paddingBottom: 0 }}>
          {footerChildren}
        </div>
      )}
    </>
  );

  return (
    <Container
      id="errorPage"
      fluid="lg"
      className={`d-flex flex-column ${
        centerOnScreen
          ? 'error-page--centered'
          : isOfflinePage
            ? 'error-page--offline align-items-center'
            : compactFooterLayout
              ? 'align-items-start'
              : 'align-items-center'
      }`}
      style={
        centerOnScreen || isOfflinePage
          ? undefined
          : { marginTop: '120px', paddingBottom: compactFooterLayout ? 16 : undefined }
      }
    >
      <div
        className={centerOnScreen ? 'error-page-centered-wrap' : 'mx-auto'}
        style={{
          width: '100%',
          maxWidth: isOfflinePage ? undefined : '600px',
        }}
      >
        {isOfflinePage && childrenBlock}
        {centerOnScreen ? (
          <div className="error-page-message-block">{messageBlock}</div>
        ) : (
          <div className={`error-page-message-wrap${isOfflinePage ? ' error-page-message-wrap--offline' : ''}`}>
            {messageBlock}
          </div>
        )}
        {belowMessageChildren ? <div className="error-page-below-message">{belowMessageChildren}</div> : null}
        <div className="error-page-actions">{actionsBlock}</div>
      </div>

      <div id="errorPageModalContainer" style={{ textAlign: 'left' }}>
        <ModalContacts modalOpen={modalOpen} setModalOpen={setModalOpen} />
      </div>
    </Container>
  );
};

export default ErrorPage;
